import React, { Component } from 'react';
import { Modal, Tooltip, message } from 'antd';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import CategoryModal from './CategoryModal';


const confirm = Modal.confirm;

class Categories extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            selectedCategory: null
        }
    }

    onAddClick() {
        this.setState({ showModal: true, selectedCategory: null });
    }

    onModalCancel() {
        this.setState({ showModal: false });
    }

    onModalSubmit(values, isNew) {

        console.log(values);
        console.log(isNew);

        if (isNew) {
            const hideLoading = message.loading('Adding Category...', 0);
            this.props.addCategory(values, (error) => {

                hideLoading();

                if (error) {
                    message.error('Error Adding Category', 2.5);
                } else {
                    // success
                    message.success('Category Added', 2.5);
                    this.setState({ showModal: false });
                }
            });
        } else {
            const hideLoading = message.loading('Saving Category...', 0);
            this.props.updateCategory(values, (error) => {

                hideLoading();

                if (error) {
                    message.error('Error Saving Category', 2.5);
                } else {
                    // success
                    message.success('Category Updated', 2.5);
                    this.setState({ showModal: false });
                }
            });
        }
    }

    onCategoryClick(category) {
        this.setState({ showModal: true, selectedCategory: category });
    }

    onDeleteClick(category) {

        confirm({
            title: 'Are you sure you want to delete this category?',
            content: `"${category.name_en}"`,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: () => {
                // perform delete
                const hideLoading = message.loading('Deleting Category...', 0);

                console.log(category);

                this.props.deleteCategory(category.id, (error) => {

                    hideLoading();

                    if (error) {
                        message.error('Error Deleting Category', 2.5);
                    } else {
                        message.success('Category Deleted', 2.5);

                        this.setState({ showModal: false, selectedCategory: null });
                    }
                });
            }
        });
    }

    renderActions(category) {
        return (
            <div className="align-center">
                <Tooltip title="Edit">
                    <a
                        onClick={() => this.onCategoryClick(category)}
                        className="btn btn-tooltip"
                        title="Edit"
                    >
                        <img src="/resources/img/ic-edit.png" alt="Edit" />
                    </a>
                </Tooltip>
                <Tooltip title="Delete">
                    <button className="btn btn-tooltip" title="Delete" onClick={() => this.onDeleteClick(category)}>
                        <img src="/resources/img/ic-delete.png" alt="Delete" />
                    </button>
                </Tooltip>
            </div>
        );
    }

    renderCategoryRows() {
        const { categories } = this.props;

        if (!categories) {
            return;
        }

        const rows = categories.map(category => {
            return (
                <tr key={category.id}>
                    <td onClick={() => this.onCategoryClick(category)}>{category.name_en}</td>
                    {this.renderActions(category)}
                </tr>
            );
        });

        return (
            <tbody>
                {rows}
            </tbody>
        );
    }

    renderTable() {
        const { categories } = this.props;

        return (
            <ReactTable
                data={categories}
                columns={[
                    {
                        Header: 'Chinese',
                        id: 'categoryZH',
                        accessor: d => <div style={{ paddingLeft: 0 }} onClick={() => this.onCategoryClick(d)}>{d.name_zh}</div>
                    },
                    {
                        Header: 'English',
                        id: 'categoryEN',
                        accessor: d => <div style={{ paddingLeft: 0 }} onClick={() => this.onCategoryClick(d)}>{d.name_en}</div>
                    },
                    {
                        Header: 'Thai',
                        id: 'categoryTH',
                        accessor: d => <div style={{ paddingLeft: 0 }} onClick={() => this.onCategoryClick(d)}>{d.name_th}</div>
                    },
                    {
                        Header: '',
                        id: 'actionButtons',
                        accessor: d => this.renderActions(d),
                        width: 60
                    }
                ]}
                defaultPageSize={10}
                className="-highlight"
            />
        );
    }

    render() {
        const { showModal, selectedCategory } = this.state;

        return (
            <div>
                <div className="function">
                    <div className="row">
                        <div className="col-md-auto" style={{ width: '82.5%' }}></div>
                        <div className="col-md-auto">
                            <a className="btn button green-btn btn-add btn-link" onClick={this.onAddClick.bind(this)}>+ New Category</a>
                        </div>
                    </div>
                </div>
                {this.renderTable()}
                {/* <table id="category-list" className="table table-list hover" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Category</th>
                            <th></th>
                        </tr>
                    </thead>
                    {this.renderCategoryRows()}
                </table> */}
                <Modal
                    visible={showModal}
                    closable={false}
                    footer={null}
                    destroyOnClose
                >
                    <CategoryModal
                        onCancel={this.onModalCancel.bind(this)}
                        onAdd={this.onModalSubmit.bind(this)}
                        initialCategory={selectedCategory}
                        onDeleteClick={this.onDeleteClick.bind(this)}
                    />
                </Modal>
            </div>
        )
    }
}

export default Categories;


// WEBPACK FOOTER //
// ./src/views/products/Categories.js